let _this = {
    /*-------------------------------------------------------------------------------
      # Cache dom and strings
    -------------------------------------------------------------------------------*/
    $dom: {
      body: $('body'),
    },
  
    vars: {},
  
    /*-------------------------------------------------------------------------------
      # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {
      let scrollpos = window.scrollY;
      const navigationheight = document.querySelector('.main-navigation');
      const brandheight = document.querySelector('.franli-branding');
  
      function add_class_on_scroll() {
        navigationheight.classList.add('is-active');
        brandheight.classList.add('is-active');
      }
  
      function remove_class_on_scroll() {
        navigationheight.classList.remove('is-active');
        brandheight.classList.remove('is-active');
      }
  
      window.addEventListener('scroll', function () {
        scrollpos = window.scrollY;
  
        if (scrollpos > 285) {
          add_class_on_scroll();
        } else {
          remove_class_on_scroll();
        }
      });
    },
  };
  
  export default _this;
  